export default "__VITE_ASSET__756fc8f3__"